import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../../ucmodal";
import { ReactComponent as EditEmailSvg } from '../../../../resources/images/edit.svg';
import Content from "./content";


/* Styles */
import styles from "./styles";


const UpdateCitiEmailModal = ({showUpdateCitiEmailModal, setShowUpdateCitiEmailModal, companyDetails}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  useEffect(() => {
    if (!showUpdateCitiEmailModal) {
    }
  }, [setShowUpdateCitiEmailModal]);


  return (
    <UCModal
      className={classes.updateCitiEmailModal}
      showModal={ showUpdateCitiEmailModal }
      setShowModal={ setShowUpdateCitiEmailModal }
      modalIcon={<EditEmailSvg /> }
      modalTitle={ <FormattedMessage id="admin.updateCitiModalTitle" /> }
      modalDescription={ <FormattedMessage id="admin.updateCitiModalDescription" /> }
      modalContent={
        <Content
          setShowModal={setShowUpdateCitiEmailModal}
          companyDetails={companyDetails}
        />
      }
      dataTestId="updateCitiEmailModal"
    />
  )
}

export default UpdateCitiEmailModal;